import React from 'react';

export default function Description(props) {
  let description = props.description;

  if (props.secret) {
    description = '🔒 '+description.split('').map((value) => {
      if (value === ' ') return value;
      return "▓";
    }).join('');
  }

  if (props.isRichText) {
    return <p dangerouslySetInnerHTML={{ __html: props.description }} />
  }

  return <p>{description}</p>;
}



// WEBPACK FOOTER //
// ./src/components/Assets/Description.js